import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SignIn } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { AppProvider } from "@/context/AppContext";
import { Toaster } from "@/components/ui/sonner";
import BackgroundStage from "@/components/BackgroundStage";
import Journey from "@/pages/Journey";
import AdminPage from "@/pages/AdminPage";
import EditBookingPage from "@/pages/EditBookingPage";
import ForumPage from "@/pages/ForumPage";

const AuthShell = ({ children }) => {
  const [idle] = useState(() => sessionStorage.getItem("jm_idle_signout") === "1");
  useEffect(() => {
    sessionStorage.removeItem("jm_idle_signout");
  }, []);
  return (
    <div className="relative z-10 flex min-h-screen flex-col items-center justify-center gap-4 p-4">
      {idle && (
        <p className="glass rounded-2xl px-5 py-3 text-sm text-amber-100" data-testid="idle-signout-notice">
          You were signed out after 30 minutes of no activity. Please sign in again.
        </p>
      )}
      {children}
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppProvider>
          <BackgroundStage />
          <ClerkAuthProvider>
            <Routes>
              <Route path="/" element={<Journey />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/edit-booking" element={<EditBookingPage />} />
              <Route path="/forum" element={<ForumPage />} />
              <Route
                path="/sign-in/*"
                element={<AuthShell><SignIn routing="path" path="/sign-in" withSignUp={false} appearance={{ elements: { footerAction: { display: "none" } } }} /></AuthShell>}
              />
              <Route path="/sign-up/*" element={<Navigate to="/sign-in" replace />} />
            </Routes>
          </ClerkAuthProvider>
          <Toaster position="top-center" richColors />
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
